import React, { useState, useEffect, useMemo } from "react";
import Container from "../../components/Container";
import * as api from "./api";
import { useFetch } from "../../components/Hooks/Conexao";
import { Divider, Menu, Drawer, Tooltip, Dropdown } from "antd";
import { BtnPadrao, DatePickerPadrao, InputPadrao, LabelPadrao } from "../../components/Base";
import TabelaPadrao from "../../components/TabelaPadrao";
import moment from "moment";
import { RightOutlined, MenuOutlined } from "@ant-design/icons";
import AnaliseExcell from "./AnaliseExcell";
import AnalisePrint from "./AnalisePrint";
import GerarPedido from "./GerarPedido";
import SelectFiltros from "../../components/SelectFiltros";
import { connect } from "react-redux";
import { logIn, fetch } from "../../actions/index";
import Mensagens from "../../components/Mensagens";
import Modal from "antd/lib/modal/Modal";
import SelectFabricantes from "../../components/SelectFabricantes";

//const INITIAL_FILTROS = { dtIni: moment().subtract('months', 3), dtFim: moment().subtract('months', 3).add('days', 1) };
const INITIAL_FILTROS = { dtIni: moment().subtract('days', 8), dtFim: moment().startOf('day').subtract('days', 1) };
const INITIAL_FILTROS_EXP = { dtIni: moment().startOf('month'), dtFim: moment().endOf('month').startOf('day').subtract('hours', 20) };

function AnaliseRepo(props) {
  const [filtros, setFiltros] = useState(INITIAL_FILTROS);
  const [filtrosExportar, setFiltrosExportar] = useState(INITIAL_FILTROS_EXP);
  const [dados, listarDados, loading] = useFetch(() => api.getAll(props.fetch, filtros));
  const [, listarDadosFile, loadingFile] = useFetch();
  const [exportarVisible, setExportarVisible] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [gerarPedidosVisible, setGerarPedidosVisible] = useState(false);

  const menuCad = (
    <Menu>
      <Menu.Item><a rel="noopener noreferrer" href="#" onClick={() => setExportarVisible(true)}>Exportar Arquivo</a></Menu.Item>
    </Menu>
  );

  const gerarArquivo = () => {
    listarDadosFile(() => api.getAll(props.fetch, filtrosExportar), c => {
      //console.log('file', c)
      const element = document.createElement("a");
      const d = JSON.stringify(c);
      let info = 'Cnpj;Ean;Codigo;Nome;Un;Fabricante;Setor;Grupo;Embalagem;Valor;Cmv;Qtd;Ano/Mes' + '\n';
      c.forEach(x => {
        const id = parseInt(x.id);
        const emp = props.pesq.empresa.find(x => x.idEmpresaDados == id);

        info += `${emp.cnpj ? emp.cnpj : '***'};${x.ean};${x.codigo};${x.nome};${x.un};${x.fabricante};${x.setor};${x.grupo};${x.embalagem};${x.valor};${x.cmv};${x.qtd};${filtrosExportar.dtIni.format('MM/YYYY')}` + '\n';
      });
      const file = new Blob([info], { type: "text/csv" });
      // console.log('dados xml', d);
      element.href = URL.createObjectURL(file);
      element.download = "analise.csv";
      document.body.appendChild(element);
      element.click();
    })
  }

  return (
    <>
      <Container loading={loading} path="anlrepo" large>
        <div>
          <Divider orientation="left">Análise e reposição</Divider>
        </div>
        <div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
              <Tooltip title="Filtros">
                <RightOutlined style={{ fontSize: 20, marginRight: 10 }} onClick={() => setDrawerVisible(true)} className="icon-styled" />
              </Tooltip>
              <div style={{ minWidth: 300 }}>
                <SelectFiltros modelo="empresa" value={filtros.loja} onChange={v => setFiltros({ ...filtros, loja: v })} placeholder="Empresa" />
              </div>
              <div style={{ display: "flex", margin: "0 10px" }}>
                <DatePickerPadrao value={filtros.dtIni} onChange={v => setFiltros({ ...filtros, dtIni: v })} style={{ marginRight: 10 }} allowClear={false} />
                <DatePickerPadrao value={filtros.dtFim} onChange={v => setFiltros({ ...filtros, dtFim: v })} allowClear={false} />
              </div>
              <div style={{ marginRight: "10px" }}>
                <InputPadrao value={filtros.filtroEstoque} onChange={v => setFiltros({ ...filtros, filtroEstoque: v.target.value })} placeholder="Estoque Ex: <= 10" />
              </div>
              <div>
                <BtnPadrao type="primary" style={{ width: "100%" }} onClick={() => { filtros.loja ? listarDados() : Mensagens.showErro("Nenhuma empresa selecionada"); }}>
                  Listar
                </BtnPadrao>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <Dropdown overlay={menuCad} placement="bottomRight">
                  <BtnPadrao><MenuOutlined /></BtnPadrao>
                </Dropdown>
              </div>
            </div>
            {(dados || !!gerarPedidosVisible) && (
              <div style={{ display: "flex", marginLeft: 20 }}>
                <AnalisePrint dados={dados} />
                <AnaliseExcell dados={dados} />
              </div>
            )}
          </div>
        </div>
        <div style={{ marginTop: 25, width: "100%", textAlign: "end" }}>
          {!!(dados || []).length && (<BtnPadrao type="link" onClick={() => setGerarPedidosVisible(true)}>Gerar Pedido</BtnPadrao>)}
        </div>

        <div className="tabela-wrapper-branca">
          <TabelaDados dados={dados} />
        </div>
      </Container>
      <Drawer visible={drawerVisible} placement="left" width={400} onClose={() => setDrawerVisible(false)}>
        <SelectFabricantes style={{ marginTop: 20 }} value={filtros.fabricantes} onChange={v => setFiltros({ ...filtros, fabricantes: v })} mode="multiple" maxTagCount={5} />
        <div style={{ margin: "20px 0" }}>
          <SelectFiltros modelo="setor" value={filtros.setores} onChange={v => setFiltros({ ...filtros, setores: v })} mode="multiple" maxTagCount={5} placeholder="Setor" />
        </div>
        <div>
          <SelectFiltros modelo="grupo" value={filtros.grupos} onChange={v => setFiltros({ ...filtros, grupos: v })} mode="multiple" maxTagCount={5} placeholder="Grupo" />
        </div>
      </Drawer>
      {/* <pre>{JSON.stringify(dados, null, 2)}</pre> */}
      {gerarPedidosVisible && <GerarPedido fetch={props.fetch} visible={gerarPedidosVisible} dados={dados} id={filtros.loja} dtIni={filtros.dtIni} dtFim={filtros.dtFim} onCancel={() => setGerarPedidosVisible(false)} />}

      <Modal
        visible={exportarVisible}
        title="Exportação de arquivo"
        onCancel={() => setExportarVisible(false)}
        width={500}
        footer={<><BtnPadrao type="primary" onClick={gerarArquivo} loading={loadingFile}>Gerar</BtnPadrao><BtnPadrao style={{ marginLeft: 8 }} onClick={() => setExportarVisible(false)}>Sair</BtnPadrao></>}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", width: '100%' }}>
            {/* <div style={{ minWidth: 150 }}>
              <SelectFiltros modelo="empresa" value={filtrosExportar.lojas} onChange={v => setFiltrosExportar({ ...filtrosExportar, lojas: v })} placeholder="Empresa" mode="multiple" />
            </div> */}
            <div style={{ display: "flex", margin: "0 10px" }}>
              {/* <DatePickerPadrao value={filtrosExportar.dtIni} onChange={v => setFiltrosExportar({ ...filtrosExportar, dtIni: v })} style={{ marginRight: 10 }} allowClear={false} />
              <DatePickerPadrao value={filtrosExportar.dtFim} onChange={v => setFiltrosExportar({ ...filtrosExportar, dtFim: v })} allowClear={false} /> */}

              <DatePickerPadrao value={filtrosExportar.dtIni} onChange={v => setFiltrosExportar({ ...filtrosExportar, dtIni: v.clone().startOf('month'), dtFim: v.clone().endOf('month').subtract('hours', 20) })} allowClear={false} picker="month" />
            </div>
            <div style={{ marginRight: "10px" }}>
              <InputPadrao value={filtrosExportar.filtroEstoque} onChange={v => setFiltrosExportar({ ...filtrosExportar, filtroEstoque: v.target.value })} placeholder="Estoque Ex: <= 10" />
            </div>
          </div>
        </div>

        {/* <pre>{JSON.stringify(filtrosExportar, null, 2)}</pre> */}
      </Modal>
    </>
  );
}

const TabelaDados = React.memo(({ dados }) => {
  return (

    <TabelaPadrao columns={columns} data={dados} style={{ margin: "25px 0" }} />

  );
});

const mapStateToProps = state => {
  return { pesq: state.pesq };
};

export default connect(mapStateToProps, { logIn, fetch })(AnaliseRepo);

const columns = [
  {
    Header: "EAN",
    accessor: "ean",
  },
  {
    Header: "CÓDIGO",
    accessor: "codigo",
  },
  {
    Header: "NOME",
    accessor: "nome",
  },
  {
    Header: "UN",
    accessor: "un",
  },
  {
    Header: "FABRICANTE",
    accessor: "fabricante",
  },
  {
    Header: "SETOR",
    accessor: "setor",
  },
  {
    Header: "GRUPO",
    accessor: "grupo",
  },
  {
    Header: "EMBALAGEM",
    accessor: "embalagem",
    tipo: "dec",
  },
  {
    Header: "VALOR",
    accessor: "valor",
    tipo: "rs",
  },
  {
    Header: "CMV",
    accessor: "cmv",
    tipo: "rs",
  },

  {
    Header: "QTD",
    accessor: "qtd",
    tipo: "int",
  },
  {
    Header: "ESTOQUE",
    accessor: "estoque",
    tipo: "int",
  },
  {
    Header: "ESTOQUE MIN",
    accessor: "estoqueMin",
    tipo: "int",
  },
  {
    Header: "ESTOQUE MAX",
    accessor: "estoqueMax",
    tipo: "int",
  },
  {
    Header: "GIRO",
    accessor: "giro",
    tipo: "dec",
  },
];
